<template>
  <div class="box box__update-app" v-if="isUpdated">
    <div class="box__cnt">
      <p>A new app version is available!</p>
      <button class="btn btn-primary btn-sm" @click="updateApp">Click to update</button>
    </div>
  </div>
</template>

<script>
import store from '@/store';

export default {
  name: 'app-update',
  props: {
    appVersion: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    isUpdated() {
      if (this.appVersion && store.getters.appVersion !== this.appVersion) {
        return true;
      }
      return false;
    },
  },
  created() {
  },
  methods: {
    updateApp() {
      store.commit('setAppVersion', this.appVersion);
      window.location.reload();
    },
  },
};
</script>

<style scoped>
/* update app */
.box__update-app {
  margin-bottom: 70px !important;
  margin-top: 20px;
}

@media (min-width: 992px) {
  .box__update-app {
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }
}
</style>
